import updateMiniCart from "./update-mini-cart";
import updateCartIconQuantity from "./update-cart-icon";
import updateDatalayer from "./gtm";
import Modal from "./modal/modal";
import $ from "jquery";
import {registerHtmlHook} from "../utils/htmlHooks";

let addToCartBtn = document.querySelectorAll('.add-to-cart');

function addToCart(elements) {
    Array.from(elements).forEach((element, index) => {
        element.addEventListener('click', (event) => {
            event.preventDefault();
            // overlay(true);
            let productId = $(event.target).closest('a,button').data('product-id');
            let input = $('div.quantity[data-product-id="'+productId+'"]').find('input[type="number"]');

            let val = input.val();
            let quantity = val !== undefined ? parseFloat(val) || parseInt(val) : 1;

            // Start check if quantity counter is inside product card
            let cardActionsEl = event.target.closest('.is-card__actions');
            if (cardActionsEl) {
                let inputField = cardActionsEl.querySelector('.is-number-input__input')
                if (inputField) {
                    quantity = inputField.value;
                }
            }

            if (isNaN(quantity)) {
                quantity = 1;
            }

            // End check if quantity counter is inside product card

            let cartData = {
                product_id: productId,
                quantity: quantity,
            };

            let productOptions = {};
            $('[name^="option-group"]').each(function (index) {
                let group = $(this).data('group'), option = $(this).data('option');
                if (!group || ($(this).is('[type="text"]') && $(this).val().trim() === '')) {
                    return true;
                }
                if (!$(this).is(':disabled') && ($(this).is('[type="text"]') || $(this).is('select') || $(this).is(':checked'))) {
                    productOptions[group] = {
                        ...productOptions[group],
                        [option || $(this).val()]: $(this).val()
                    };
                }
            });

            if (Object.keys(productOptions).length > 0) {
                cartData['option-groups'] = productOptions;
            }

            $('.group-content').removeClass('option-missing');

            window.axios.post(window.config.urls.addToCart, cartData, {overlay: true}).then(({data: data}) => {
                if (data.success) {
                    let modal = $('#addToCartModal');
                    modal.find('#addToCartModalContent').html(data.content);
                    modal.modal('show');
                    //overlay(false);
                    updateMiniCart().then(updateCartIconQuantity);
                    updateDatalayer(
                        'add_to_cart',
                        data.cartItem.attributes.snapshot.material_number,
                        data.cartItem.name,
                        data.cartItem.quantity,
                        data.cartItem.price,
                        null
                    );
                } else if (data.message) {
                    new Modal({
                        title: window.config.language.errorOccurred,
                        content: Modal.createErrorMessage(data.message),
                        buttons: Modal.buttons.alert,
                    }).show();
                }
            }).catch((error) => {
                if (error.response.data.groups) {
                    Array.from(error.response.data.groups).forEach((group) => {
                        $('#group-anchor-' + group).addClass('option-missing');
                        $('#group-content-' + group).addClass('option-missing');
                    });
                }
                if (error.response.status !== 422 && error.response.data.message) {
                    new Modal({
                        title: window.config.language.errorOccurred,
                        content: Modal.createErrorMessage(error.response.data.message),
                        buttons: Modal.buttons.alert,
                    }).show();
                }
            });
        });
    });
}

if (addToCartBtn.length > 0) {
    addToCart(addToCartBtn);
}

const goToCart = $('.go-to-cart');
goToCart.on('click', function (e) {
    let modal = $('#addToCartModal');
    modal.modal('hide');
    window.location.href = window.config.urls.cart;
})

registerHtmlHook((container) => addToCart(container.querySelectorAll('.add-to-cart')));

export default addToCart;
